import Command from "@ckeditor/ckeditor5-core/src/command";
import { CkeditorConstants } from '../../src/utils/ckeditorconstants';

const { htmlElement: { DIV }, helperAttributes: { NO_ONE },
  helperAttributes: { SUBTEMPLATE_NAME } } = CkeditorConstants;

export default class RemoveSubtemplateCommand extends Command {
  execute() {
    const range = this.editor.editing.view.createRangeIn(
      this.editor.editing.view.document.getRoot()
    );
    const mapper =
      this.editor.editing.mapper

    this.editor.model.change(writer => {
        for (const viewItem of range.getItems({ ignoreElementEnd: true })) {
            const modelItem = mapper.toModelElement(viewItem);
            if (
              viewItem.is('view:element') && [...viewItem.getAttributeKeys()].includes(SUBTEMPLATE_NAME) &&
              ![...modelItem.getChildren()].length
            ) {
              if (
                modelItem.previousSibling &&
                modelItem.previousSibling.name === DIV &&
                modelItem.previousSibling.hasAttribute(NO_ONE) &&
                ![...modelItem.previousSibling.getChildren()].length
              ) {
                writer.remove(modelItem.previousSibling);
              }
              writer.remove(modelItem);
            }
        }
    })

  }

}